






import { computed, defineComponent, ref } from "@vue/composition-api";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { FormFields } from "@/types";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseView from "@/components/BlockBaseView.vue";
import { fields } from "./config";
import { timeAgo } from "@/lib/helpers/time";

export default defineComponent({
  name: "BlockRegistrationInformation",
  components: { BlockBaseView, BlockBase },
  props: {
    user: { type: Object as () => User, required: true },
  },
  setup(props) {
    const title = ref<string>("Registration Information");
    const fieldsResult = computed(
      (): FormFields => {
        let { accountInfo } = props.user;
        return fields.map(item => {
          // if (item.name === "lastOnlineTime" && onlineStatus?.lastOnlineTime != null) {
          //   item.value = timeAgo(onlineStatus.lastOnlineTime);
          // } else {
          item.value = accountInfo[item.name as keyof typeof accountInfo];
          // }
          return item;
        });
      }
    );

    return { title, fieldsResult };
  },
});
